import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import GoBack from "../General/GoBack";
import ResultadoFecha from "./ResultadoFecha";
import API_URL from "../../localhost/config"; //Importa la variable global
import Sidebar from "../Sidebar/Sidebar";

const partidoDiv = (match) => {
  return (
    <div
      className="card my-3"
      style={{ maxWidth: "700px", margin: "0 auto", marginTop: "20px" }}
    >
      <div className="card-body">
        <h5 className="card-title">
          {" "}
          {match.Dia ? "Partido asignado" : "Partido no asignado"}
        </h5>
        <div className="row">
          <div className="col-md-6">
            <p className="card-text">
              <strong>Equipo 1:</strong> {match.equipo1_nombre}
            </p>
          </div>
          <div className="col-md-6">
            <p className="card-text">
              <strong>Equipo 2:</strong> {match.equipo2_nombre}
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            {match.nombreCancha ? (
              <p className="card-text">
                {" "}
                <strong>Cancha:</strong> {match.nombreCancha}{" "}
              </p>
            ) : null}
          </div>
          <div className="col-md-6">
            {match.Dia ? (
              <p className="card-text">
                {" "}
                <strong>Día:</strong> {match.Dia}{" "}
              </p>
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            {match.horario ? (
              <p className="card-text">
                {" "}
                <strong>Horario:</strong> {match.horario}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

const Fecha = () => {
  const { idTorneo, idFecha } = useParams();

  const [detallesFecha, setDetallesFecha] = useState(null);
  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    const obtenerDetallesFecha = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/getResultByDate/resultados?idFecha=${idFecha}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setDetallesFecha(response.data);
      } catch (error) {
        console.error(
          "Error al obtener los detalles de la fecha:",
          error.response?.data?.message || error.message
        );
      }
    };

    obtenerDetallesFecha();
  }, [idFecha]);

  if (!detallesFecha) {
    return <p>Cargando detalles de la fecha...</p>;
  }

  return (
    <div className="row p-0 g-0">
      <div className="col-sm-auto p-0 g-0 flex-column">
        <Sidebar />
      </div>
      <div className="col-sm p-0 g-0">
        <div className="section-title mt-5">
          <h3>
            Fecha <span>{detallesFecha.fecha}</span>
          </h3>
        </div>
        {detallesFecha.map((partido) => partidoDiv(partido))}
      </div>
    </div>
  );
};

export default Fecha;
